import { CTA } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useSelectedFilterStore } from '../store/filtersv2';
import { getTranslations } from '../translations';
import { Language } from '../types';
import { useFeatureServices } from '../use-feature-services';
import { getFilterList } from '../utils/get-filter-list';
import { getSingleSelectedDealer } from '../utils/get-single-selected-dealer';
import { createConstantData, createPartner } from '../utils/get-tracking-event-data';
import { useFiltering } from '../utils/use-filtering';

export const ResetButton = () => {
  const { labels } = getTranslations();
  const { resetSelectedFilters } = useFiltering();
  const { selected } = useSelectedFilterStore();

  const { tracking } = useFeatureServices();
  const { labels: enLabels } = getTranslations(Language.EN);
  const partner = getSingleSelectedDealer();

  const handleOnClick = () => {
    resetSelectedFilters();

    tracking.track('VWBasic_FilterSearchSave_Click', {
      ...createConstantData(),
      partner: createPartner(partner),
      link: {
        url: window.location.href,
        name: enLabels.reset_filters
      },
      filters: {
        type: 'complex',
        name: 'More options',
        filterList: getFilterList(selected)
      }
    })
  };

  return (
    <CTA
      tag="button"
      onClick={handleOnClick}
      emphasis="tertiary"
    >
      { labels.reset_filters }
    </CTA>
  );
};
